import Reveal from "@/components/Reveal";

const Section = ({ title, children }) => (
  <Reveal>
    <div className="mt-12">
      <h2 className="font-display font-bold text-2xl text-teal">{title}</h2>
      <div className="mt-4 space-y-4 text-sm md:text-base leading-relaxed text-teal/75">{children}</div>
    </div>
  </Reveal>
);

const Privacy = () => (
  <div className="min-h-screen bg-cream pt-32 pb-24" data-testid="privacy-page">
    <div className="max-w-3xl mx-auto px-6">
      <Reveal className="text-center mb-4">
        <p className="text-xs uppercase tracking-[0.4em] text-teal/70 font-medium">Your Privacy</p>
        <h1 className="font-display font-bold text-4xl md:text-5xl mt-3 text-teal">Privacy Notice</h1>
        <div className="mt-5 h-px w-20 bg-gold mx-auto" />
      </Reveal>
      <Reveal>
        <p className="mt-8 text-sm md:text-base leading-relaxed text-teal/75">
          This notice explains how Morelli&rsquo;s Ice Cream Parlour, 14 Victoria Parade,
          Broadstairs, Kent CT10 1QS (&ldquo;we&rdquo;, &ldquo;us&rdquo;) collects and uses
          personal information through this website. If you have any questions, email us
          at <a href="mailto:info@morellis.com" className="underline hover:text-gold transition-colors">info@morellis.com</a>.
        </p>
      </Reveal>

      <Section title="What we collect">
        <ul className="list-disc pl-5 space-y-2">
          <li><strong>Newsletter:</strong> your email address, only when you tick the box asking to receive occasional news and promotions.</li>
          <li><strong>Loyalty card (The Morelli&rsquo;s Circle):</strong> your name, email address, password (stored securely scrambled, never readable), and optionally your birthday day and month so we can treat you.</li>
          <li><strong>Guestbook reviews:</strong> the name you give and your review text, which is shown publicly on this website.</li>
          <li><strong>Shop orders:</strong> your name, email, order contents and, for delivery orders, your postal address.</li>
        </ul>
      </Section>

      <Section title="Why we collect it">
        <ul className="list-disc pl-5 space-y-2">
          <li>To send you the newsletter you asked for (you can unsubscribe anytime).</li>
          <li>To run your loyalty card — counting stamps and rewards, and sending service emails such as password resets and your birthday treat.</li>
          <li>To display guestbook reviews you choose to publish.</li>
          <li>To fulfil shop orders and let you know they&rsquo;re ready.</li>
        </ul>
        <p>We only use your information for these purposes, and we never sell it to anyone.</p>
      </Section>

      <Section title="Who receives it">
        <ul className="list-disc pl-5 space-y-2">
          <li>Our email service provider, to deliver newsletters and account emails.</li>
          <li>Stripe, our payment processor, if you pay by card — we never see or store your card details.</li>
          <li>Our website hosting provider, where the information is stored securely.</li>
        </ul>
      </Section>

      <Section title="How long we keep it">
        <p>
          Newsletter details until you unsubscribe; loyalty accounts while you remain a
          member; reviews while they are displayed on the site; and order records for up
          to six years for accounting purposes. You can ask us to delete your information
          at any time (see below).
        </p>
      </Section>

      <Section title="Cookies and the map">
        <p>
          This website itself does not set tracking cookies. The optional map in our
          Visit section is provided by OpenStreetMap and may set cookies — it only loads
          if you press &ldquo;Accept&rdquo; on our cookie notice. You can change your choice
          anytime by clearing your browser&rsquo;s stored data for this site.
        </p>
      </Section>

      <Section title="Your rights">
        <p>
          You can ask us at any time to see, correct or delete the personal information
          we hold about you — just email
          <a href="mailto:info@morellis.com" className="underline hover:text-gold transition-colors"> info@morellis.com</a>.
          If you&rsquo;re unhappy with how we handle your information, you have the right to
          complain to the Information Commissioner&rsquo;s Office (ICO) at
          <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer" className="underline hover:text-gold transition-colors"> ico.org.uk</a> or
          on 0303 123 1113.
        </p>
      </Section>

      <Reveal>
        <p className="mt-14 text-xs text-teal/50 italic">Last updated: August 2026</p>
      </Reveal>
    </div>
  </div>
);

export default Privacy;
